<template>
  <div>
    <video id="videoPlayer" class="video-js" controls preload="auto" :width="width" :height="height" data-setup='{}'>
      <source :src="name">

    </video>
  </div>

</template>

<script setup>

//import videojs from 'video.js';

import { computed } from "@vue/reactivity"
import { ref, onMounted, onBeforeUnmount } from 'vue'

import { useConnectionStore } from '@/stores/connectionStore';

const connectionStore = useConnectionStore()

const props = defineProps({
    height : {
      type : Number,      
      default : 400
    },
    width : {
      type : Number,
      default : 600
    },
    name : {
      type : String,
      default : ""
    },
    egg : {
      type : Boolean,
      default : false
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  })

  var player = null
  var options = {}

  const name = computed({
    get() {
      return props.name
    }
  })

  const width = computed({
    get() {
      return props.width
    }
  })

  const height = computed({
    get() {
      return props.height
    }
  })

  onMounted(() => {
    player = videojs("videoPlayer")
  })

  onBeforeUnmount(() => {
    if (player) {
      player.dispose();
    }
  })

// export default {
//   name: 'VideoPlayer',
  
//   data() {
//     return {
//       player: null
//     }
//   },
//   mounted() {
//     this.player = videojs(this.$refs.videoPlayer, this.options, () => {
//       this.player.log('onPlayerReady', this);
//     });
//   },
//   beforeDestroy() {
//     if (this.player) {
//       this.player.dispose();
//     }
//   }
// }

</script>

<style scoped>

.video-container {
  position: relative;
  margin-top : 10px;
  margin-left : 10px;
}

</style>